const estimateFPS = async (): Promise<number> => {
  return new Promise((resolve) => {
    let frames = 0;
    const start = performance.now();

    const loop = () => {
      frames++;
      if (performance.now() - start < 1000) {
        requestAnimationFrame(loop);
      } else {
        resolve(frames);
      }
    };

    loop();
  });
};

export const getAdaptiveTimeout = async (): Promise<number> => {
  const fps = await estimateFPS();
  return Math.max(100, 1000 / fps);
};
